import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    ...theme.mixins.toolbar,
  },
}));
